export var findPlayerById = function (players) {
    return function (id) {
        return players.find(function (player) { return player.id === id; });
    };
};
